import { createSlice } from '@reduxjs/toolkit'

import { APPCONFIG } from '../configs/app'

const initialState = {
  lang: 'cn',
  activeTab: 0
}

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.lang = action.payload

      if (document) document.title = APPCONFIG.title[state.lang]
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload
    }
  }
})

export const { setLanguage, setActiveTab } = appSlice.actions

export default appSlice.reducer